// sessionSyncWithAlert.js - 세션 변경 감지 (전역 변수 기반)

import { getCookie, deleteCookie } from "../utils/cookie";
import { fetchCurrentLoginUser } from "./Login/oAuthReloadSync";

let rememberedUserId = null;
let reloadTriggered = false;
let sessionHandled = false; // ✅ 세션 변경 처리 여부 기록
let versionCheckFailed = false; // ✅ 버전 체크 실패 시 재시도 방지
const CURRENT_APP_VERSION = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "0.0.0";
console.log("현재 앱 버전:", CURRENT_APP_VERSION);

export async function initSessionSync() {
  console.log("initSessionSync");

  if (isStandaloneApp()) {
    checkAppVersion();

    //iOS PWA 환경에서 비로그인 상태 안내 문구 표시
    if (isIOS() && !getCookie("mId")) {
      showLoginNoticeBanner();
    }
  }

  // 최초 진입 시 rememberedUserId 저장
  // rememberedUserId = getData("rememberedUserId");
  // const currentUserId = getCookie("mId");

  // if (!rememberedUserId && currentUserId) {
  //   rememberedUserId = currentUserId;
  //   setData("rememberedUserId", currentUserId);
  // }

  // 항상 현재 로그인 사용자 기준으로 초기화(사용자가 바뀌었을 경우 새로고침 이슈로 수정 - 250529)
  // const currentUserId = getCookie("mId");
  // rememberedUserId = currentUserId;
  const user = await fetchCurrentLoginUser();
  rememberedUserId = user?.mId || null;
  setData("rememberedUserId", rememberedUserId);

  // 포커스 시 쿠키 변경 직접 감지
  // window.addEventListener("focus", async () => {
  //   if (reloadTriggered || sessionHandled) return;

  //   if (isStandaloneApp()) {
  //     checkAppVersion();
  //   }

  //   // const latestUserId = getCookie("mId") || null;
  //   const user = await fetchCurrentLoginUser();
  //   const latestUserId = user?.mId || null;

  //   const isLoggedOut = rememberedUserId && !latestUserId;
  //   const isSwitchedUser = rememberedUserId && latestUserId && rememberedUserId !== latestUserId;
  //   const isLoggedIn = !rememberedUserId && latestUserId;
  //   const hasSessionChanged = isLoggedOut || isSwitchedUser || isLoggedIn;
  //   console.log('hasSessionChanged', hasSessionChanged)

  //   if (hasSessionChanged) {
  //     reloadTriggered = true;
  //     sessionHandled = true;
  //     let message = "세션이 변경되어 다시 로그인합니다.";
  //     if (isLoggedOut) message = "세션이 만료되어 로그아웃되었습니다.";
  //     else if (isSwitchedUser) message = "다른 사용자로 로그인되어 세션이 변경되었습니다.";
  //     else if (isLoggedIn) message = "세션이 새로 생성되어 로그인되었습니다.";
  //     handleSessionChange(message);
  //   }
  // });


  window.addEventListener("focus", async () => {
      if (reloadTriggered || sessionHandled) return;

      if (isStandaloneApp()) {
        checkAppVersion();
      }

      const user = await fetchCurrentLoginUser();
      const latestUserId = user?.mId || null;

      const cookie_mId = getCookie("mId");
      const cookie_idToken = getCookie("idToken");

      const isValidCookie = v =>
          v !== null && v !== undefined && v !== "" && v !== "undefined";

      const wasLoggedIn = !!rememberedUserId;
      const isNowLoggedIn = !!latestUserId;

      const isLoggedOut = wasLoggedIn && !isNowLoggedIn;
      const isSwitchedUser = wasLoggedIn && isNowLoggedIn && rememberedUserId !== latestUserId;
      const isLoggedIn = !wasLoggedIn && isNowLoggedIn;

      const idChanged = rememberedUserId !== latestUserId;

      const cookieMissingWhileLoggedIn =
          latestUserId && (!isValidCookie(cookie_mId) || !isValidCookie(cookie_idToken));

      const cookieExistsWhileLoggedOut =
          !latestUserId && (isValidCookie(cookie_mId) || isValidCookie(cookie_idToken));

      const cookieChanged =
          idChanged ||
          cookieMissingWhileLoggedIn ||
          cookieExistsWhileLoggedOut;

      const hasSessionChanged =
          isLoggedOut ||
          isSwitchedUser ||
          isLoggedIn ||
          cookieChanged;

      console.log('hasSessionChanged', hasSessionChanged);

      if (hasSessionChanged) {
        reloadTriggered = true;
        sessionHandled = true;

        let message = "세션이 변경되어 다시 로그인합니다.";
        if (isLoggedOut) message = "세션이 만료되어 로그아웃되었습니다.";
        else if (isSwitchedUser) message = "다른 사용자로 로그인되어 세션이 변경되었습니다.";
        else if (isLoggedIn) message = "세션이 새로 생성되어 로그인되었습니다.";

        handleSessionChange(message);
      }
  });
}

// 앱 버전 체크: 항상 현재 경로 기준 ./version.txt 로 요청 (오류 시 재시도 방지)
export function checkAppVersion() {
  if (versionCheckFailed) return;

  fetch("./version.txt", { cache: "no-store" })
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.text();
    })
    .then((latestVersion) => {
      console.log("최신 앱 버전:", latestVersion.trim());
      if (latestVersion.trim() !== CURRENT_APP_VERSION) {
        console.log("🔄 앱 버전이 다릅니다. 새로고침합니다.");
        location.reload(true);
      }
    })
    .catch((err) => {
      console.warn("버전 체크 실패:", err.message);
      versionCheckFailed = true;
    });
}

function isStandaloneApp() {
  const isDisplayStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isDisplayFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
  const isIOSStandalone = window.navigator.standalone === true;
  return isDisplayStandalone || isDisplayFullscreen || isIOSStandalone;
}

function isIOS() {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
  // alert('isIOS' + isIOS)
  return isIOS;
}

async function handleSessionChange(message) {
  // const latestUserId = getCookie("mId") || null;
  console.log("handleSessionChange 실행됨");

  const user = await fetchCurrentLoginUser();
  const latestUserId = user?.mId || null;

  deleteCookie("mId");
  deleteCookie("idToken");
  deleteCookie("idTokenSession");

  console.log("fetch 기반 latestUserId:", latestUserId);
  rememberedUserId = latestUserId;
  setData("rememberedUserId", latestUserId);
  // alert(message);
  location.reload();
}

function showLoginNoticeBanner() {
  const notice = document.createElement("div");
  notice.classList.add('notice')
  notice.innerHTML = `앱은 브라우저와 로그인 상태가 다를 수 있습니다.<br/>현재 비로그인 상태로 실행 중입니다.
                      <span class="btn-notice-close"></span>`;

  const closeBtn = notice.querySelector('.btn-notice-close');
  closeBtn.onclick = () => notice.remove();
  notice.prepend(closeBtn);

  document.body.appendChild(notice);
}

export function clearSessionMemory() {
  rememberedUserId = null;
}

export function setSessionMemory() {
  rememberedUserId = getCookie('mId');
}

function setData(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function getData(key) {
  const item = localStorage.getItem(key);
  if (item === null || item === "undefined") return null;

  try {
    return JSON.parse(item);
  } catch (e) {
    console.error("JSON parse error:", e);
    return null;
  }
}